@if (!handleRedirect && !customLoginPage) {
  <div class="login-background d-flex flex-column justify-content-between align-items-center">
    <div class="login-header">
      <img
        data-testid="udt-hub-logo"
        src="../../../../assets/images/header-logo.png"
        alt="UDTHub header logo"
        width="150px"
      />
      <button mat-icon-button (click)="openCustomerTraining()">
        @if (!isFetchingCustomerTraining && canDisplayCustomerTrainingIcon) {
          <mat-icon
            class="customer-training-help-button"
            matTooltipClass="bigger-tooltip"
            data-testid="training-material-button"
            tabindex="0"
            alt="Help center logo"
            >help</mat-icon
          >
        }
        @if (isFetchingCustomerTraining && !canDisplayCustomerTrainingIcon) {
          <div class="d-flex justify-content-center align-items-center">
            <mat-spinner data-testid="login-training-material-loading-indicator" [diameter]="26"></mat-spinner>
          </div>
        }
      </button>
    </div>
    <div class="w-100 h-100 d-flex">
      <div class="welcome__container w-25 h-100 d-flex align-items-center justify-content-center">
        <div class="signin__container ml-5">
          <h1 class="font-size-headline3 text-udt-blue headline" data-testid="welcome-title">Welcome</h1>
          <p class="m-0 mb-4 description" data-testid="welcome-message">
            Sign into your account to access your customer portal
          </p>
          <button
            mat-flat-button
            color="primary"
            class="large-button h-auto"
            (click)="logInPressed()"
            [disabled]="redirectMessage !== null"
            data-testid="sign-in-button"
          >
            Go to Sign In
            @if (redirectMessage !== null) {
              <mat-spinner class="white-spinner" [diameter]="18"></mat-spinner>
            }
          </button>
        </div>
      </div>
      <div class="info__container w-75 h-100">
        <div class="middle"></div>
        <div class="d-flex flex-column align-items-center">
          <div class="w-50 d-flex flex-column align-items-center">
            <h2 class="text-white mr-auto font-size-headline4 subheadline" data-testid="hub-features-title">
              UDTHub Features!
            </h2>
            <div class="info__container-video d-flex justify-content-center align-items-center">
              <iframe
                data-testid="hub-features-video"
                style="width: 95%; height: 90%"
                src="https://www.youtube.com/embed/qes29jIb3oA?rel=0&amp;controls=0&amp;showinfo=0"
                title="UDTHUB Introduction Video"
                frameborder="0"
                allowfullscreen
              >
              </iframe>
            </div>
          </div>
          @if (!isLoadingPortals) {
            <div class="info__container-portals d-flex justify-content-center align-items-center">
              <button mat-icon-button class="text-white" aria-label="Next hub feature button" (click)="leftClick()">
                <mat-icon>chevron_left</mat-icon>
              </button>
              <div class="carousel__content d-flex w-100">
                @for (portal of carouselPortals; track portal.name + $index) {
                  <div class="carousel__content-item">
                    <div>
                      <img
                        class="mb-2"
                        src="../../../../../assets/images/icons/{{ portal.icon }}"
                        [ngStyle]="{ width: portal.iconSize }"
                        [alt]="portal.name + ' Logo'"
                      />
                      <p class="m-0 py-2 text-white subheadline2">{{ portal.name }}</p>
                      <p class="m-0 text-white">{{ portal.description }}</p>
                    </div>
                  </div>
                }
              </div>
              <button mat-icon-button class="text-white" aria-label="Next hub feature button" (click)="rightClick()">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="login-footer d-flex justify-content-between align-items-center">
      <img
        src="../../../../assets/svg/udt-hub-logo.svg"
        data-testid="udt-logo"
        class="img-fluid"
        style="max-width: 80px"
        alt="UDTHub footer logo"
      />
      <div class="d-flex">
        <a
          class="btn social-fab d-flex justify-content-center align-items-center"
          href="https://www.linkedin.com/company/udtcorp/"
          target="_blank"
        >
          <i class="fab fa-linkedin" alt="Linkedin logo"></i>
        </a>
        <a
          class="btn social-fab d-flex justify-content-center align-items-center"
          href="https://twitter.com/UDTCorp"
          target="_blank"
        >
          <i class="fab fa-twitter" alt="Twitter logo"></i>
        </a>
        <a
          class="btn social-fab d-flex justify-content-center align-items-center"
          href="https://www.facebook.com/UDTCorp/"
          target="_blank"
        >
          <i class="fab fa-facebook" alt="Facebook logo"></i>
        </a>
        <a
          class="btn social-fab d-flex justify-content-center align-items-center"
          href="https://www.instagram.com/udtcorp/"
          target="_blank"
        >
          <i class="fab fa-instagram" alt="Instagram logo"></i>
        </a>
        <a
          class="btn social-fab d-flex justify-content-center align-items-center"
          href="https://www.youtube.com/user/UDTvideo"
          target="_blank"
        >
          <i class="fab fa-youtube" alt="YouTube logo"></i>
        </a>
      </div>
    </div>
  </div>
}
@if (handleRedirect || customLoginPage) {
  <div class="handleRedirect loading-background">
    <mat-spinner [diameter]="36" style="margin-right: 1rem"></mat-spinner>
    <span style="font-size: 14pt" class="ml-3">Redirecting</span>
  </div>
}
